import customFetch from '../../utils/customFetch'
import { getDefaultLogger } from '../../services/logger/logger'
import {
  IPostSimilarObjectsCount,
  IPostSimilarSearchRequests,
  SimilarObjectsResponse,
  SimilarSearchResponse,
} from '../../@types/my-property-service-types'

const REACT_APP_MY_PROPERTY_SERVICE_API = process.env.REACT_APP_MY_PROPERTY_SERVICE_API || 'http://localhost:5001'

const credentialsPolicy = 'include'

const postMyPropertyServiceCount = async <T>(
  endpoint: string,
  body: Record<string, unknown>,
  extractCount: (data: T) => number,
  errorContext: string
): Promise<number | undefined> => {
  const url = `${REACT_APP_MY_PROPERTY_SERVICE_API}${endpoint}`

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: credentialsPolicy,
    body: JSON.stringify(body),
  }

  try {
    const response = await customFetch(url, options)
    if (response.status === 200) {
      const data = (await response.json()) as T
      return extractCount(data)
    }

    getDefaultLogger().warn(`Failed to load ${errorContext} from My Property Service API`, response)
    return undefined
  } catch (error) {
    getDefaultLogger().warn(`Failed to load ${errorContext}`, error)
    return undefined
  }
}

export const postSimilarObjectsSellCount = ({
  location,
  livingArea,
  price,
  type,
}: IPostSimilarObjectsCount): Promise<number | undefined> => {
  return postMyPropertyServiceCount<SimilarObjectsResponse>(
    '/search/similar-objects/sell/count',
    { location, livingArea, price, type },
    (data) => data.numberOfSimilarObjects,
    'similar objects count (sell)'
  )
}

export const postSimilarObjectsRentCount = ({
  location,
  livingArea,
  price,
  type,
}: IPostSimilarObjectsCount): Promise<number | undefined> => {
  return postMyPropertyServiceCount<SimilarObjectsResponse>(
    '/search/similar-objects/rent/count',
    { location, livingArea, price, type },
    (data) => data.numberOfSimilarObjects,
    'similar objects count (rent)'
  )
}

export const postSimilarSearchRequestsSellCount = ({
  location,
  livingArea,
  type,
}: IPostSimilarSearchRequests): Promise<number | undefined> => {
  return postMyPropertyServiceCount<SimilarSearchResponse>(
    '/search/similar-search-requests/sell/count',
    { location, livingArea, type, excludeGermanyWideSearches: true, priceRangeGiven: false },
    (data) => data.numberOfSimilarSearchRequests,
    'similar search requests count (sell)'
  )
}

export const postSimilarSearchRequestsRentCount = ({
  location,
  livingArea,
  type,
}: IPostSimilarSearchRequests): Promise<number | undefined> => {
  return postMyPropertyServiceCount<SimilarSearchResponse>(
    '/search/similar-search-requests/rent/count',
    { location, livingArea, type, excludeGermanyWideSearches: true, priceRangeGiven: false },
    (data) => data.numberOfSimilarSearchRequests,
    'similar search requests count (rent)'
  )
}
